import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { getAdminDrugClasses } from '@api/adminLookups';
import { IDrugClass } from '@interfaces/lookups';

export const handleGetAdminDrugClasses = createAsyncThunk<
  AxiosResponse<IDrugClass[]>,
  {
    programCode: number;
  }
>('getAdminDrugClasses', ({ programCode }) => getAdminDrugClasses(programCode));
